import { render, staticRenderFns } from "./MissingSyncRequirements.vue?vue&type=template&id=2fbf2b1c&scoped=true&"
import script from "./MissingSyncRequirements.vue?vue&type=script&lang=js&"
export * from "./MissingSyncRequirements.vue?vue&type=script&lang=js&"
import style0 from "./MissingSyncRequirements.vue?vue&type=style&index=0&id=2fbf2b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbf2b1c",
  null
  
)

/* custom blocks */
import block0 from "./MissingSyncRequirements.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports